<div class="save-and-facet-container">
  <div for="filter Name" class="filter-name-container">
    <div class="filter-name">
      <div id="filter-name-display" class="name">
        <span> Current name </span>
        <div>
          <span
            class="name"
            *ngIf="displayFilterName.length >= 30"
            [title]="displayFilterName"
            >{{ displayFilterName | textEllipsis: 30 }}</span
          >
          <span class="name" *ngIf="displayFilterName.length < 30">{{
            displayFilterName
          }}</span>
          <span
            *ngIf="showChangeBadge"
            class="change-icon"
            nz-tooltip
            nzTooltipTitle="You have unsaved changes."
          >
            <va-icon size="small" name="circle" style="color: #ffc846"></va-icon
          ></span>
        </div>
      </div>
      <!-- <nz-divider nzType="vertical" style="height: 43px;"></nz-divider> -->
    </div>
  </div>
  <div class="facet-column">
    <app-database-facet-selected-filters [(siderCollapsed)]="siderCollapsed">
    </app-database-facet-selected-filters>
  </div>

  <div for="save-controls" class="save-controls">
    <div id="facet-save-controls">
      <nz-button-group class="save-control save-buttons">
        <va-button
          btnType="outline"
          size="small"
          [isOnlyIcon]="true"
          [title]="'save'"
          (onClick)="onSave()"
          class="save-button"
        >
          <va-icon size="small" name="save"></va-icon>
        </va-button>
        <va-button
          size="small"
          btnType="outline"
          [isOnlyIcon]="true"
          nz-dropdown
          [nzDropdownMenu]="saveMenu"
          nzPlacement="bottomRight"
          nzTrigger="click"
          nzBackdrop="false"
          class="save-button-dd"
        >
          <va-icon size="small" name="chevron-down"></va-icon>
        </va-button>
      </nz-button-group>
      <va-button
        class="save-control save-buttons"
        btnType="outline"
        size="small"
        [isOnlyIcon]="true"
        (onClick)="onOpen()"
        [title]="'saved filters'"
      >
        <va-icon size="small" name="folder-open"></va-icon>
      </va-button>
      <va-button
        btnType="outline"
        class="save-buttons reset-btn"
        size="small"
        (onClick)="onReset()"
      >
        Reset
      </va-button>

      <nz-dropdown-menu #saveMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="onSave()">
            <div class="dropdown-btn">
              <span>Save</span>
            </div>
          </li>
          <li nz-menu-item (click)="onSaveAs()">
            <div class="dropdown-btn">
              <span>Save as...</span>
            </div>
          </li>
          <li nz-menu-item (click)="onRevertToLastSaved()">
            <div class="dropdown-btn">
              <span>Revert to last saved</span>
            </div>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <nz-modal
      [(nzVisible)]="showSavedFilterModal"
      [nzFooter]="null"
      nzWidth="672px"
      (nzOnCancel)="handleSavedFilterCancel()"
      nzTitle="Saved Filters"
      nzWrapClassName="pharma-modal"
    >
      <ng-container *nzModalContent>
        <div class="skeleton-container" *ngIf="loadingSavedFilters">
          <va-custom-skeleton
            [customSkeletonConfig]="{
              skeletonType: 'list',
              config: {
                list: {
                  noOfListItems: 6
                }
              }
            }"
          ></va-custom-skeleton>
        </div>

        <div class="error-container" *ngIf="savedFilterError">
          <div class="error-msg">
            <va-icon name="info-circle" class="info-icon"></va-icon>
            <span class="error-text">Something went wrong!</span>
          </div>
        </div>

        <div
          class="all-saved-filters-container"
          *ngIf="!loadingSavedFilters && !savedFilterError"
        >
          <ng-container
            *ngIf="savedFilterList.length !== 0; else emptyCompBlock"
          >
            <ul nz-menu class="saved-filters-holder">
              <li
                nz-menu-item
                *ngFor="let data of savedFilterList"
                class="filter-item"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <div class="filter-name-holder" #check>
                  <div
                    class="input-with-action"
                    *ngIf="data.inEditMode; else displayName"
                  >
                    <input
                      #filterRename
                      nz-input
                      nzSize="small"
                      [(ngModel)]="currentFilterName"
                      (keyup)="onNameChange(data)"
                      maxlength="75"
                      minlength="1"
                      [class.in-edit-mode]="data.inEditMode"
                      [class.error]="filterNameError"
                      class="filter-name-input"
                    />
                    <span
                      class="error-color name-error-msg"
                      [hidden]="!filterNameError"
                    >
                      <va-icon name="info-circle" class="info-icon"></va-icon>
                      {{ nameError }}
                    </span>
                    <div
                      class="save-edit-holder toggle-icon-onhover"
                      [class.in-edit-mode]="data.inEditMode"
                    >
                      <span
                        class="save-icon"
                        (click)="toggleEditMode($event, data)"
                        ><va-icon
                          size="small"
                          name="save"
                          class="va-icon"
                        ></va-icon
                      ></span>
                      <span
                        class="delete-icon"
                        (click)="showDeleteAlertModal($event, data)"
                        ><va-icon
                          size="small"
                          name="trash"
                          class="va-icon"
                        ></va-icon
                      ></span>
                    </div>
                  </div>
                  <ng-template #displayName>
                    <div class="input-with-action" (click)="selectFilter(data)">
                      <div class="display-name" [title]="data.filter_name">
                        {{ data.filter_name }}
                      </div>
                      <div
                        class="save-edit-holder toggle-icon-onhover"
                        style="border-bottom: 1px solid #36abad"
                        [class.in-edit-mode]="data.inEditMode"
                      >
                        <span
                          class="edit-icon"
                          (click)="toggleEditMode($event, data)"
                          ><va-icon
                            name="edit"
                            class="va-icon"
                            size="small"
                          ></va-icon
                        ></span>
                        <span
                          class="delete-icon"
                          (click)="showDeleteAlertModal($event, data)"
                          ><va-icon
                            name="trash"
                            class="va-icon"
                            size="small"
                          ></va-icon
                        ></span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </li>
            </ul>
          </ng-container>
          <ng-template #emptyCompBlock>
            <div class="error-container">
              <div class="error-msg">
                <va-icon name="info-circle" class="info-icon"></va-icon>
                <span class="error-text">You have not saved any filters</span>
              </div>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </nz-modal>
    <nz-modal
      [(nzVisible)]="showSaveAsNameModal"
      [nzOkDisabled]="removeWhiteSpaces(currentFilterName) === ''"
      nzTitle="Save As"
      (nzOnCancel)="handleSaveAsCancelModal()"
      (nzOnOk)="handleSaveAsOkModal()"
      nzWidth="462px"
      nzOkText="Save"
      nzCancelText="Cancel"
      nzClassName="save-as-filter-modal"
      nzWrapClassName="pharma-modal"
    >
      <ng-container *nzModalContent>
        <div class="save-name">
          <label class="name-label">Name:</label>
          <input
            type="text"
            name="current-filter-name"
            id="filterName"
            [(ngModel)]="currentFilterName"
          />
        </div>
      </ng-container>
    </nz-modal>
    <nz-modal
      [(nzVisible)]="showDeleteModal"
      nzTitle="Delete"
      (nzOnCancel)="closeDeleteModal()"
      (nzOnOk)="deleteFilter()"
      nzWidth="475px"
      nzOkText="Delete"
      nzCancelText="Cancel"
      nzClassName="delete-filter-modal"
      nzWrapClassName="pharma-modal"
    >
      <ng-container *nzModalContent>
        <div class="delete-filter">
          <span
            >Please confirm that you’d like to permanently delete
            {{ deletedFilterObj ? deletedFilterObj.filter_name : "" }}</span
          >
        </div>
      </ng-container>
    </nz-modal>
  </div>
</div>
